import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'formatoCostoDesde', standalone: true})
export class FormatoCostosDesde implements PipeTransform {
  transform(value: number): string {
    let formatoCosto = "";
    if (value!=null) {
      formatoCosto = value.toString().replace(".", ",");
    }
    return formatoCosto;
  }
}
